"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCartSchema = exports.APosEcommerceCartItemSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
// NOTE: named APosEcommerceCartItem* (not APosCartItem*) to avoid colliding
// with the pre-existing POS-transaction APosCartItemSchema. This is the
// storefront/ecommerce cart line item (UNIFIED-MODEL §6.1).
exports.APosEcommerceCartItemSchema = zod_1.z.object({
    variantId: zod_1.z.string().min(1),
    productId: zod_1.z.string().min(1),
    quantity: zod_1.z.number().int().positive(),
    // Renamed from tenantIdForMarketplace per UNIFIED-MODEL §6.1.
    sellerTenantId: id_schema_1.TenantIdSchema,
    marketplaceId: zod_1.z.string().optional(),
    unitPrice: zod_1.z.number().nonnegative().optional(),
    addedAt: zod_1.z.number().optional(),
});
exports.APosCartSchema = zod_1.z.object({
    cartId: zod_1.z.string().min(1),
    mode: zod_1.z.enum(['tenant', 'marketplace']).default('tenant'),
    tenantId: id_schema_1.TenantIdSchema,
    marketplaceId: zod_1.z.string().optional(),
    customerId: zod_1.z.string().optional(),
    items: zod_1.z.array(exports.APosEcommerceCartItemSchema).default([]),
    // DynamoDB TTL attribute (unix seconds).
    ttl: zod_1.z.number().int().positive(),
}).merge(timestamps_schema_1.TimestampsSchema);
//# sourceMappingURL=cart.schema.js.map